module.exports = __webpack_public_path__ + "assets/img/6ba8100b32b6959f54dc8f19e4b873ac.png";